module.exports = __webpack_public_path__ + "assets/img/android-landscape1.a760bdc.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/android-landscape1.png
// module id = u+YQ
// module chunks = 50